import React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIosNew';
import {useTheme} from "@mui/material";

interface Template {
    id: string;
    name: string;
    thumbnailUrl: string;
}

interface TemplateCardProps {
    template: Template;
    onClick: (id: string) => void;
}

// Styled components
const CardContainer = styled(Box)(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    border: '1px solid rgba(255, 255, 255, 0.44)',
    '&:hover': {
        transform: 'scale(1.02)',
    }
}));

const ImageContainer = styled(Box)({
    position: 'relative',
    aspectRatio: '1/1',
    width: '100%',
    height: '100%',
});

const TemplateImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
});

const TitleBar = styled(Box)(({theme}) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(111.13deg, rgba(5, 22, 36, 0.92) 45.71%, rgba(2, 89, 137, 0.92) 117.8%)',
    padding: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

const ArrowButton = styled(Box)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
}));

const TemplateCard: React.FC<TemplateCardProps> = ({template, onClick}) => {
    const theme = useTheme();
    const isRtl = theme.direction === 'rtl';

    return (
        <CardContainer onClick={() => onClick(template.id)}>
            <ImageContainer>
                <TemplateImage
                    src={template.thumbnailUrl}
                    alt={template.name}
                    loading="lazy"
                />
                <TitleBar>
                    <Typography variant="body1" sx={{
                        color: 'white',
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {template.name}
                    </Typography>
                    <ArrowButton>
                        {isRtl ? (
                            <ArrowBackIosIcon fontSize="small"/>
                        ) : (
                            <ArrowForwardIosIcon fontSize="small"/>
                        )}
                    </ArrowButton>
                </TitleBar>
            </ImageContainer>
        </CardContainer>
    );
};

export default TemplateCard;